import { dataAssetsApi } from '@/api'
import { SearchTagsSearchTags } from '@coac-gmbh/saifty-main-apis'
import { computed, ref } from 'vue'
import { IS_BASF } from '@/config/customers'
import { useSAPConfig } from './useSAPConfig'

export interface SearchItem {
  tag: string
  value: string
  active?: boolean
  toggle?: boolean
}

export interface ToggleSearchItem {
  tag: string
  value: string
  active: boolean
  toggle: boolean
}
export interface DefaultSearch {
  canonicalName: string
  optionTag: string
}

const ALL_SEARCH_TAG = 'ALL'
export const RECORD_NO_SEARCH_TAG = 'SEC_0_RECORD_NO'
export const CAS_NO_SEARCH_TAG = 'SEC_1_1_CAS'
export const EG_NR_SEARCH_TAG = 'SEC_1_EG_NR'
export const NAME_SEARCH_TAG = 'SEC_1_1_NAME'
export const PRODUCT_NUMBER_TAG = 'SEC_1_1_NUMBER'
export const AUTHORIZATION_GROUP_TAG = 'SEC_0_AUTHORIZATION_GROUP'
export const DATA_ASSET_ID_TAG = 'DATA_ASSETS_ID'
export const DATA_ASSET_NAME_TAG = 'name'
export const ARTICLE_NUMBER_SEARCH_TAG = 'SEC_1_1_NUMBER'
export const DATA_ASSET_SEARCH_TAG = 'name'
export const DATAOBJECT_CERTIFICATE_TYPE_TAG = 'DATA_CERTIFICATETYPE'
export const NAM_RAW_TAG = 'SEC_1_1_NAM_RAW'
export const REG_SUPPL_TAG = 'SEC_1_1_REG_SUPPL'
export const SYNONYMS_TAG = 'SEC_1_1_SYNONYMS'
export const INDEX_NR_TAG = 'SEC_1_1_INDEX_NR'
export const REG_NR_TAG = 'SEC_1_1_REG_NR'
export const MANUFACTURER_TAG = 'SEC_1_3_MANUFACTURER'
export const MATERIAL_GROUP_SEARCH_TAG = 'SEC_0_1_MATERIAL_GROUP'
export const FILE_NAME_SEARCH_TAG = 'SEC_0_FILENAME'
export const HAZ_STAT_RAW_SEARCH_TAG = 'SEC_2_2_3_1_HAZ_STAT_RAW'

export const DEFAULT_SEARCH_TAGS = [
  { canonicalName: 'SEC_1_1.NAM_RAW', optionTag: NAM_RAW_TAG },
  { canonicalName: 'SEC_1_1.SYNONYMS', optionTag: SYNONYMS_TAG },
  { canonicalName: 'SEC_1_1.CAS', optionTag: CAS_NO_SEARCH_TAG },
  { canonicalName: 'SEC_1_1.INDEX_NR', optionTag: INDEX_NR_TAG },
  { canonicalName: 'SEC_1_1.NAME', optionTag: NAME_SEARCH_TAG },
  { canonicalName: 'SEC_1_1.NUMBER', optionTag: PRODUCT_NUMBER_TAG },
  { canonicalName: 'SEC_1_1.REG_NR', optionTag: REG_NR_TAG },
  { canonicalName: 'SEC_1_1.REG_SUPPL', optionTag: REG_SUPPL_TAG },
]

const searchTags = ref<Array<SearchTagsSearchTags>>([])
const loadingSearchTags = ref(false)

export default function useSearchTags() {
  const { getConfigByBusinessUnit } = useSAPConfig()

  const searchOptions = computed(() => {
    return searchTags.value.map((el) => {
      let name = el.displayName || el.searchableKey || '-'

      if (name === 'Article Number') {
        name = 'Number'
      }

      if (IS_BASF) {
        if (name === 'Article Name') {
          name = 'Name'
        }
      } else if (name === 'Article Number') {
        name = 'Number'
      }

      return { name, value: el.searchableKey || '-' }
    })
  })

  /*
   * Loading and error handling performed in WithLoadingPromise
   */
  async function loadSearchTags() {
    if (loadingSearchTags.value) return

    loadingSearchTags.value = true
    if (searchTags.value.length === 0) {
      const { data } = await dataAssetsApi.getAllPossibleDataAssetAttributes()
      searchTags.value = data.search_tags || []
    }
    loadingSearchTags.value = false
  }

  function getAdditionalDefaultSearchValues({
    businessUnit = undefined,
    currentCasNo = undefined,
    dataAssetName = undefined,
    authGroup = undefined,
  }: {
    businessUnit?: string
    currentCasNo?: string
    dataAssetName?: string
    authGroup?: string
  }) {
    const dataFromSAPConfig = getConfigByBusinessUnit(businessUnit)

    const COMPONENT_RELATED_DATA_ASSET =
      dataAssetName ||
      dataFromSAPConfig?.sap_component_related_data_asset_name ||
      window.ENV.COMPONENT_RELATED_DATA_ASSET ||
      ''

    const COMPONENT_RELATED_AUTHORIZATION_GROUP =
      authGroup ||
      dataFromSAPConfig?.sap_component_related_auth_group ||
      window.ENV.COMPONENT_RELATED_AUTHORIZATION_GROUP ||
      ''

    let additionalDefaultSearchValues: ToggleSearchItem[] = []

    if (COMPONENT_RELATED_DATA_ASSET) {
      additionalDefaultSearchValues = [
        {
          tag: DATA_ASSET_NAME_TAG,
          value: COMPONENT_RELATED_DATA_ASSET,
          active: true,
          toggle: true,
        },
      ]
    }
    if (COMPONENT_RELATED_AUTHORIZATION_GROUP) {
      additionalDefaultSearchValues.push({
        tag: AUTHORIZATION_GROUP_TAG,
        value: COMPONENT_RELATED_AUTHORIZATION_GROUP,
        active: true,
        toggle: true,
      })
    }
    if (currentCasNo) {
      additionalDefaultSearchValues.push({
        tag: CAS_NO_SEARCH_TAG,
        value: currentCasNo,
        active: true,
        toggle: true,
      })
    }

    return additionalDefaultSearchValues
  }

  return {
    searchTags,
    searchOptions,
    ALL_SEARCH_TAG,
    ARTICLE_NUMBER_SEARCH_TAG,
    DATA_ASSET_SEARCH_TAG,
    RECORD_NO_SEARCH_TAG,
    CAS_NO_SEARCH_TAG,
    EG_NR_SEARCH_TAG,
    NAME_SEARCH_TAG,
    DATA_ASSET_NAME_TAG,
    PRODUCT_NUMBER_TAG,
    AUTHORIZATION_GROUP_TAG,
    DATA_ASSET_ID_TAG,
    loadSearchTags,
    getAdditionalDefaultSearchValues,
  }
}
